<template>
<svg id="check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.27 47.38"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1" points="88.52 47.38 0 47.38 0 0 88.52 0 113.27 23.7 88.52 47.38"/><path class="cls-2" d="M31,22.22a1.68,1.68,0,0,0-1,.27,2,2,0,0,0-.63.68,2.83,2.83,0,0,0-.35.92,4.75,4.75,0,0,0-.1,1,4.63,4.63,0,0,0,.1,1,3,3,0,0,0,.33.89,1.87,1.87,0,0,0,.62.66,1.7,1.7,0,0,0,.95.25,1.79,1.79,0,0,0,1.34-.48,2.33,2.33,0,0,0,.58-1.3H35.2a4,4,0,0,1-1.36,2.67,4.39,4.39,0,0,1-2.87.91,4.82,4.82,0,0,1-1.81-.33,4,4,0,0,1-1.4-.92,4.1,4.1,0,0,1-.9-1.42,4.86,4.86,0,0,1-.33-1.81,5.82,5.82,0,0,1,.3-1.9,4.21,4.21,0,0,1,.88-1.51,3.89,3.89,0,0,1,1.41-1,4.74,4.74,0,0,1,1.9-.35,5.45,5.45,0,0,1,1.51.2,4.06,4.06,0,0,1,1.29.62,3.17,3.17,0,0,1,.92,1,3.2,3.2,0,0,1,.41,1.47H32.79A1.63,1.63,0,0,0,31,22.22Z"/><path class="cls-2" d="M39.15,17.29v4.58h.05a2.79,2.79,0,0,1,1.17-1.12,3.19,3.19,0,0,1,1.39-.34,4,4,0,0,1,1.59.26,2.3,2.3,0,0,1,1,.73,2.7,2.7,0,0,1,.5,1.14A6.83,6.83,0,0,1,45,24v5.4H42.56v-5a3.07,3.07,0,0,0-.34-1.63,1.32,1.32,0,0,0-1.2-.53,1.65,1.65,0,0,0-1.43.59,3.21,3.21,0,0,0-.44,1.93v4.6H36.73V17.29Z"/><path class="cls-2" d="M49.57,27.32a2.11,2.11,0,0,0,1.56.53,2.17,2.17,0,0,0,1.26-.36,1.58,1.58,0,0,0,.65-.78h2.12A4,4,0,0,1,53.6,29a4.58,4.58,0,0,1-2.55.68,5,5,0,0,1-1.87-.33,3.76,3.76,0,0,1-1.41-.94,4.27,4.27,0,0,1-.9-1.46,5.36,5.36,0,0,1-.31-1.87,5.27,5.27,0,0,1,.32-1.84,4.26,4.26,0,0,1,.92-1.47,4.45,4.45,0,0,1,1.42-1,4.52,4.52,0,0,1,1.83-.35,4.15,4.15,0,0,1,2,.43A4,4,0,0,1,54.37,22a4.82,4.82,0,0,1,.77,1.67,6,6,0,0,1,.17,2H49A2.41,2.41,0,0,0,49.57,27.32ZM52.3,22.7A1.69,1.69,0,0,0,51,22.22a2.07,2.07,0,0,0-1,.2,1.76,1.76,0,0,0-.61.48,1.7,1.7,0,0,0-.33.62,2.7,2.7,0,0,0-.11.57H52.9A2.84,2.84,0,0,0,52.3,22.7Z"/><path class="cls-2" d="M61.11,22.22a1.66,1.66,0,0,0-1,.27,2.09,2.09,0,0,0-.64.68,2.82,2.82,0,0,0-.34.92,4.77,4.77,0,0,0-.11,1,4.65,4.65,0,0,0,.11,1,2.56,2.56,0,0,0,.33.89,1.87,1.87,0,0,0,.62.66,1.68,1.68,0,0,0,1,.25,1.76,1.76,0,0,0,1.33-.48,2.28,2.28,0,0,0,.59-1.3h2.33A4,4,0,0,1,64,28.74a4.41,4.41,0,0,1-2.87.91,4.82,4.82,0,0,1-1.81-.33,4.15,4.15,0,0,1-1.41-.92A4.41,4.41,0,0,1,57,27a5.06,5.06,0,0,1-.32-1.81,5.82,5.82,0,0,1,.3-1.9,4.18,4.18,0,0,1,.87-1.51,4.07,4.07,0,0,1,1.41-1,4.79,4.79,0,0,1,1.91-.35,5.33,5.33,0,0,1,1.5.2,4.06,4.06,0,0,1,1.29.62,3.22,3.22,0,0,1,1.34,2.51H62.89A1.61,1.61,0,0,0,61.11,22.22Z"/><path class="cls-2" d="M69.47,17.29v6.52l3-3.17h2.85l-3.31,3.23,3.69,5.56H72.82l-2.41-3.92-.94.9v3H67.06V17.29Z"/></g></g></svg>
</template>






<script>
export default {
name: 'check'
    
}



</script>

<style>



.cls-1show-all{fill:#f58e58;}.cls-2show-all{fill:#fff;}


.cls-2-yellow{
    fill:yellow;
}

.cls-2-white{
    fill:#ffffff;
}

svg#check{
    height: 48px;
    /* margin: 10px auto; */
}
.cls-1{fill:#f58e58;}.cls-2{fill:#fff;}
</style>